import { IDate, IYearMonth } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * IDate型を日付フォーマットに変換する
 * @param date - IDate型の日付
 * @param dateFormat - 日付フォーマット指定
 */
export const convertIDateToDateFormat = (date: IDate, dateFormat: DateFormat = 'YYYY/MM/DD'): string => {
  // 月と日を0埋めする
  const useMonth = DateService.convertMonthWithZero(date.month);
  const useDay = DateService.convertMonthWithZero(date.day);
  switch (dateFormat) {
    case 'YYYY/MM/DD':
      return date.year + '/' + useMonth + '/' + useDay;
    case 'YYYY/MM':
      return date.year + '/' + useMonth;
    case 'YYYY-MM-DD':
      return date.year + '-' + useMonth + '-' + useDay;
    case 'YYYY-MM':
      return date.year + '-' + useMonth;
    case 'YYYYMMDD':
      return date.year + '' + useMonth + '' + useDay;
    case 'YYYYMM':
      return date.year + '' + useMonth;
  }
};

/**
 * IYearMonth型をyyyy/MMフォーマットに変換する
 * @param date - IDate型の日付
 */
export const convertIDateToYYYYMM = (date: IYearMonth): string => {
  return date.year + '/' + date.month;
};

/**
 * unixTimeをIDateに変換する
 * **timeがミリ秒単位であることに注意**
 * TODO: 240806 - coreDomainsModule/services/dateService.ts で同名の関数があるので整備する
 * @param time - unixTime（ミリ秒）
 */
export const convertUnixTimeToIDate = (time: number): IDate => {
  const date = new Date(time);
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};

/**
 * 日付フォーマット形式
 */
type DateFormat = 'YYYY/MM/DD' | 'YYYY/MM' | 'YYYY-MM-DD' | 'YYYY-MM' | 'YYYYMMDD' | 'YYYYMM';
